import axiosInstance from '../config/axios.js';

const API_BASE = '/locations';

const locationService = {
  // Get all locations with optional filters and pagination
  getAll: async (page = 1, perPage = 10, params = {}) => {
    const queryParams = {
      page,
      per_page: perPage,
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get all locations without pagination
  getAllLocations: async (params = {}) => {
    const queryParams = {
      all: 'true',
      ...params
    };
    const response = await axiosInstance.get(API_BASE, { params: queryParams });
    return response.data;
  },

  // Get location by ID
  getById: async (locationId) => {
    const response = await axiosInstance.get(`${API_BASE}/${locationId}`);
    return response.data;
  },

  // Get all unique states
  getStates: async () => {
    const response = await axiosInstance.get(`${API_BASE}/states`);
    return response.data;
  },

  // Create new location
  create: async (locationData) => {
    const response = await axiosInstance.post(API_BASE, locationData);
    return response.data;
  },

  // Update location
  update: async (locationId, locationData) => {
    const response = await axiosInstance.put(`${API_BASE}/${locationId}`, locationData);
    return response.data;
  },

  // Delete location
  delete: async (locationId) => {
    const response = await axiosInstance.delete(`${API_BASE}/${locationId}`);
    return response.data;
  }
};

export default locationService;